import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { generatePath } from "react-router-dom";

export default function useRevokeLink() {
  const queryClient = useQueryClient();

  const revokeLink = (id: string) => {
    const request: Request = {
      url: generatePath(ENDPOINTS.links.revoke, { id }),
      config: {
        method: "patch",
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<Response<null>, Error, string>(
    revokeLink,
    {
      onSettled: (data, error, id) => {
        queryClient.invalidateQueries([ENDPOINTS.links.block]);
      },
    }
  );

  return { data, mutate, ...rest };
}
